/**
 * Timer Helper is used to get the Remaining time and Formatted Time etc
 * UTC based time diff will be added based on the requirement.
 *
 * A Timer helper is available to calcualate the remaining Time, Logic is separated
 * so if remaining Time is <= 0 you can display a different component as required
 *
 */

class TimerHelper {
    /**
     * @param endDate {DATE} is taken to find difference
     * @param cachedTtl {DATA} timestamp when the local storage was set
     * @param ttlLimit - {INT} Minutes after which the local storage cache should be purged
     */
    static isExpired(endDate, cachedTtl, ttlLimit) {
        // Check if the end date of the offer is expired
        const timeDiff = Date.parse(endDate) - Date.now();
        const diffMs = Date.now() - cachedTtl;

        return Math.round(diffMs / 60000) > ttlLimit || timeDiff < 0 || ttlLimit === 0;
    }

    /**

    /**
     * @param endtime {DATE} is taken to find difference
     * @param starttime {DATE} is taken to find the difference optional
     * if not passed then will take it from latest value.
     */
    static getTimeRemaining(endtime, starttime = new Date()) {
        const t = Date.parse(endtime) - Date.parse(starttime);

        if (t < 0) {
            return {
                total: -1,
                days: 0,
                hours: 0,
                minutes: 0,
                seconds: 0,
            };
        }
        const seconds = Math.floor((t / 1000) % 60);
        const minutes = Math.floor((t / 1000 / 60) % 60);
        const hours = Math.floor((t / (1000 * 60 * 60)) % 24);
        const days = Math.floor(t / (1000 * 60 * 60 * 24));
        return {
            total: t,
            days,
            hours,
            minutes,
            seconds,
        };
    }

    /**
     * @param milliseconds {NUMBER} remaining milliseconds
     * @returns {OBJECT} with hours, minutes, and seconds
     */

    static getFormattedTime(milliseconds, removePrecedingZeros, addAdditionalMinute) {
        const rawSeconds = milliseconds / 1000;
        let seconds = Math.floor(rawSeconds % 60);
        let minutes = Math.floor((rawSeconds / 60) % 60);
        let hours = Math.floor((milliseconds / (1000 * 60 * 60)) % 24);

        /* istanbul ignore next */
        if (addAdditionalMinute) {
            minutes += 1;
        }

        if (!removePrecedingZeros) {
            /* istanbul ignore next */
            seconds = seconds < 10 ? `0${seconds}` : seconds;
            /* istanbul ignore next */
            minutes = minutes < 10 ? `0${minutes}` : minutes;
            hours = hours < 10 ? `0${hours}` : hours;
        }

        return {
            hours,
            minutes,
            seconds,
        };
    }

    static fetchUrgencyMessage(today, urgencyDate) {
        const currentDate = today || new Date();
        const totalTime = Date.parse(urgencyDate) - Date.parse(currentDate);
        return totalTime < 0;
    }

    static getremainingTimerDetailsData(endtime, today, eventBasedTimer = true, dayTimer = false) {
        const currentDate = today || new Date();
        const totalTime = Date.parse(endtime) - Date.parse(currentDate);
        // If coupon has already expired, return all empty to hide the timer
        /* istanbul ignore next */
        if (totalTime < 0) {
            return {
                total: -1,
                hours: 0,
                minutes: 0,
                seconds: 0,
                daysLeft: 0,
            };
        }
        const offerEndDate = new Date(endtime);
        const daysLeft = Math.ceil(totalTime / (1000 * 3600 * 24));
        const isTodayLastDay = offerEndDate.getTime() - currentDate.getTime() < 0;
        const endOfToday = new Date(
            currentDate.getFullYear(),
            currentDate.getMonth(),
            currentDate.getDate() + 1,
            0,
            0,
            0
        );
        let diff2 = endOfToday.getTime() - currentDate.getTime();
        if (isTodayLastDay || (eventBasedTimer && !dayTimer)) {
            diff2 = offerEndDate.getTime() - currentDate.getTime();
        }
        let msec = diff2;
        const hours = Math.floor(msec / 1000 / 60 / 60);
        msec -= hours * 1000 * 60 * 60;
        const minutes = Math.floor(msec / 1000 / 60);
        msec -= minutes * 1000 * 60;
        const seconds = Math.floor(msec / 1000);
        msec -= seconds * 1000;
        return {
            total: totalTime,
            hours,
            minutes,
            seconds,
            isTodayLastDay,
            daysLeft,
        };
    }

    static getFormattedRemainingTime(
        startTime,
        endtime,
        finalDayThreshold,
        today,
        dayTimer,
        eventBasedTimer
    ) {
        const formattedTime = TimerHelper.getremainingTimerDetailsData(
            endtime,
            today,
            eventBasedTimer,
            dayTimer
        );
        const seconds =
            formattedTime.seconds < 10 ? `0${formattedTime.seconds}` : formattedTime.seconds;
        /* istanbul ignore next */
        const minutes =
            formattedTime.minutes < 10 ? `0${formattedTime.minutes}` : formattedTime.minutes;
        const hours = formattedTime.hours < 10 ? `0${formattedTime.hours}` : formattedTime.hours;

        return {
            hours,
            minutes,
            seconds,
        };
    }

    static getDigitSplit(number) {
        return number.toString().split('').map(Number);
    }

    static getDaysLeft(endtime, today) {
        const currentDate = today || new Date();
        const totalTime = Date.parse(endtime) - Date.parse(currentDate);
        const daysLeft = Math.floor(totalTime / (1000 * 3600 * 24));
        return daysLeft;
    }
}

export default TimerHelper;
